// extracted by mini-css-extract-plugin
export default {"print-page":"PrintPage_print-page__wkcCv","container":"PrintPage_container__IuvfL","header-wrapper":"PrintPage_header-wrapper__1PT+Q","header-image":"PrintPage_header-image__xHKLf"};